export class Choice {
  id: number = 0;
  value: string = '';
  checked: Boolean = false;
}
